/* ヘッダーのスクロール追従判定。
   ページが少しでもスクロールされたらラッパーに .is-stuck を付ける。
   CSS 側でそのとき下段の余白を詰める。

   position: sticky 自体は CSS だけで効くが、「今くっついているか」は
   CSS からは判定できないためここで付け外しする。 */
(function () {
  var header = document.querySelector('.section-digimoku-header');
  if (!header) return;

  // 追従が始まったとみなす閾値（上段の高さぶん）
  var THRESHOLD = 10;
  var ticking = false;

  function update() {
    ticking = false;
    var stuck = window.scrollY > THRESHOLD;
    header.classList.toggle('is-stuck', stuck);
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();
})();

/* パネルが画面下端までに収まるよう、パネル上端の位置を CSS 変数に渡す。
   CSS だけでは実測高さを取れないためここで測る。 */
(function () {
  var header = document.querySelector('.digimoku-header');
  var top = document.querySelector('.digimoku-header__top');
  if (!header || !top) return;

  function update() {
    header.style.setProperty('--menu-panel-offset', Math.round(top.getBoundingClientRect().height) + 'px');
    header.style.setProperty('--header-full-height', Math.round(header.getBoundingClientRect().bottom) + 'px');
  }

  update();
  window.addEventListener('resize', update, { passive: true });
  window.addEventListener('scroll', update, { passive: true });

  if (window.ResizeObserver) {
    var observer = new ResizeObserver(update);
    observer.observe(top);
    observer.observe(header);
  }
})();

/* ナビのドロップダウン。マウスはホバーで開閉する。
   <details> の open は CSS から触れないのでここで付け外しする。
   キーボード操作（フォーカス／Esc）でも開けるようにしてある。 */
(function () {
  var dropdowns = document.querySelectorAll('.digimoku-header__dropdown');
  if (!dropdowns.length) return;

  // 閉じるのを少し遅らせる。ナビとパネルの間をカーソルが
  // 横切る一瞬で閉じてしまうのを防ぐ。
  var CLOSE_DELAY = 200;
  var closeTimer = null;

  function cancelClose() {
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeAll(except) {
    for (var i = 0; i < dropdowns.length; i++) {
      if (dropdowns[i] !== except) dropdowns[i].removeAttribute('open');
    }
  }

  function open(dropdown) {
    cancelClose();
    closeAll(dropdown); // 同時に開くのは1つだけ
    dropdown.setAttribute('open', '');
  }

  function scheduleClose() {
    cancelClose();
    closeTimer = setTimeout(function () {
      closeAll(null);
    }, CLOSE_DELAY);
  }

  for (var i = 0; i < dropdowns.length; i++) {
    (function (dropdown) {
      dropdown.addEventListener('mouseenter', function () {
        open(dropdown);
      });
      dropdown.addEventListener('mouseleave', scheduleClose);

      // summary のクリックで開閉がトグルされると、ホバーで開いた直後に
      // 閉じてしまう。マウス操作では既定動作を止める。
      var summary = dropdown.querySelector(':scope > summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          // detail が 0 のときはキーボード由来なので、既定の開閉に任せる
          if (event.detail === 0) return;
          event.preventDefault();
        });
      }

      // タブ移動で中に入ったら開き、出たら閉じる
      dropdown.addEventListener('focusin', function () {
        open(dropdown);
      });
      dropdown.addEventListener('focusout', function (event) {
        if (!dropdown.contains(event.relatedTarget)) scheduleClose();
      });
    })(dropdowns[i]);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var opened = document.querySelector('.digimoku-header__dropdown[open]');
    if (!opened) return;
    cancelClose();
    closeAll(null);
    // 閉じたあとフォーカスが宙に浮かないよう、開いていた summary に戻す
    var summary = opened.querySelector(':scope > summary');
    if (summary) summary.focus();
  });
})();
